import React, { useEffect } from "react";
import globalStyles from "../../../global.less";
import styles from "./index.less";
import { setTitleDesc } from '../../../../utils/tools'

const getSty = (str: string) => styles[str];
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty("KeyPoint")} ${cla ? styles[cla] : ""}`}>
    {str}
  </span>
);

export default function ProtocolENUS() {
  useEffect(() => {
    setTitleDesc('Xiaomi Channel', '小米分销通')
  }, [])

  return (
    <div className={`${globalStyles["container"]} ${getSty("protocol-th")}`}>
      <h2 className={getSty("title-h2")}>ช่องทางเสียวหมี่_ข้อกำหนดและเงื่อนไข</h2>
      <p className={getSty("explain-title")}>แพลตฟอร์มช่องทางเสียวหมี่</p>
      <p className={getSty("explain-title")}>ข้อกำหนดและเงื่อนไข</p>
      <h5 className={getSty("explain")}>
        กรุณาอ่านข้อกำหนดและเงื่อนไขอย่างละเอียดและให้ความสนใจกับบทบัญญัติที่ปรากฏเป็นตัวหนาและตัวพิมพ์ใหญ่
      </h5>
      <p className={getSty("explain")}>
        เอกสารฉบับนี้ประกอบด้วยข้อกำหนดและเงื่อนไขทั่วไปซึ่งผู้ซื้อทำธุรกรรม ปรึกษา และจัดการข้อมูลการทำธุรกรรมกับผู้ขายโดยใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ ที่เป็นกรรมสิทธิ์ ดำเนินการ ภายใต้แบรนด์ และจัดให้โดยนิติบุคคลจัดหาสินค้าเสียวหมี่ (ซึ่งมีคำจำกัดความดังต่อไปนี้).
      </p>
      <p className={getSty("explain")}>
      ข้อกำหนดและเงื่อนไขนี้จัดทำขึ้นระหว่างผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่.​
      </p>
      <div className={getSty("item-box")}>
        <span>คำจำกัดความ</span>
        <p className={getSty("title-explain")}>
          เพื่อให้เกิดความเข้าใจและการยอมรับข้อกำหนดและเงื่อนไขที่ระบุไว้ในที่นี้อย่างครบถ้วน คำศัพท์ต่อไปนี้ไม่ว่าจะเป็นรูปเอกพจน์หรือพหูพจน์ จะมีความหมายดังที่ระบุไว้ด้านล่างนี้:
        </p>
        <ol>
          <li>
            {fonSizeBold("บัญชี")} มีความหมายตามที่กำหนดไว้ในข้อ 
            “การลงทะเบียนและการเข้าสู่ระบบแพลตฟอร์มช่องทางเสียวหมี่”.
          </li>
          <li>
            {fonSizeBold("บริษัทในเครือ")} หมายถึง สำหรับนิติบุคคลจัดหาสินค้าเสียวหมี่ บุคคลอื่นใดที่โดยตรงหรือโดยอ้อมเป็นเจ้าของหรือควบคุม หรือตกอยู่ภายใต้การควบคุมของ หรือตกอยู่ภายใต้การควบคุมร่วมกับนิติบุคคลจัดหาสินค้าเสียวหมี่นี้ คุณสมบัติบางประการอาจได้รับการสนับสนุนโดยบริษัทในเครือของนิติบุคคลจัดหาสินค้าเสียวหมี่           .
          </li>
          <li>
            {fonSizeBold("ข้อมูลที่เป็นความลับ")} หมายความว่า (1) ข้อมูลหรือข้อมูลใด ๆ ที่สร้างขึ้น โพสต์ อัปโหลด หรือสื่อสารผ่านแพลตฟอร์มช่องทางเสียวหมี่;และ (2) ข้อมูลหรือข้อมูลใด ๆ ที่เกี่ยวข้องกับการมีอยู่ การออกแบบ การจัดวาง การก่อสร้าง คุณสมบัติ เนื้อหา ฯลฯ
            ของแพลตฟอร์มช่องทางเสียวหมี่ รวมถึงการมีอยู่และข้อกำหนดของข้อกำหนดและเงื่อนไข เนื้อหาที่อัปโหลดโดยเสียวหมี่ มีความหมายตามที่ระบุไว้ในข้อ “เนื้อหาที่อัปโหลดโดยนิติบุคคลจัดหาสินค้าเสียวหมี่”.
          </li>
          <li>
            {fonSizeBold("การควบคุม")} หมายความถึงการครอบครองโดยตรงหรือโดยอ้อมของอำนาจในการกำหนดหรือก่อให้เกิดการ
            กำหนดทิศทางการบริหารจัดการและนโยบายของนิติบุคคล ไม่ว่าจะโดยการถือครองหลักทรัพย์ที่มีสิทธิออกเสียง โดยสัญญา หรือวิธีอื่นใด.
          </li>
          <li>
            {fonSizeBold("อุปกรณ์")} หมายความถึงผลิตภัณฑ์ใด ๆ ที่ผลิตและ/หรือจัดจำหน่ายโดยนิติบุคคลจัดหาสินค้าเสียวหมี่
            และ/หรือบริษัทในเครือโดยตรงและโดยอ้อม และ/หรือโดยสมาชิกอื่นใดในกลุ่มเสียวหมี่ ซึ่งมีตราสินค้า โลโก้ ป้าย เครื่องหมาย หรือสัญลักษณ์ของ Mi, เสียวหมี่, Redmi เป็นต้น.
          </li>
          <li>
            {fonSizeBold("คุณสมบัติ")} หมายความถึงคุณสมบัติที่ระบุไว้ในข้อ “คุณสมบัติ”            .
          </li>
          <li>
            {fonSizeBold("กฎหมาย")} หมายถึง กฎหมาย ข้อบังคับ ระเบียบ กฎ ระเบียบข้อบังคับ รัฐธรรมนูญ สนธิสัญญา
            กฎหมายสามัญ คำสั่งของรัฐบาล หรือข้อกำหนดหรือกฎเกณฑ์ทางกฎหมายใด ๆ ของหน่วยงานรัฐ.
          </li>
          <li>
            {fonSizeBold("ผู้ซื้อ")} หมายถึง ลูกค้าที่ซื้ออุปกรณ์บนแพลตฟอร์มช่องทางเสียวหมี่ โดยปกติรวมถึงผู้จัดจำหน่ายและผู้ค้าปลีกอิสระเนื่องจากการเข้าสู่ระบบและการเข้าถึงแพลตฟอร์มช่องทางเสียวหมี่ดำเนินการในนามของผู้ซื้อโดยพนักงานที่ได้รับการแต่งตั้งและได้รับอนุญาต ดังนั้นการอ้างอิงถึง “ผู้ซื้อ”
            ในข้อกำหนดและเงื่อนไขนี้จึงต้องเข้าใจรวมถึงพนักงานของผู้ซื้อด้วย.
          </li>
          <li>
            {fonSizeBold("บุคลากร")} หมายถึง พนักงาน ตัวแทน ตัวแทนจำหน่าย ผู้รับเหมาช่วง หรือบุคคลภายนอกใด ๆ ที่เกี่ยวข้องหรือได้รับการแต่งตั้งโดยผู้ใช้ รวมถึงผู้ซื้อหรือผู้ขาย            .
          </li>
          <li>
            {fonSizeBold("ผู้ขาย")} หมายถึง ผู้ขายที่ใช้แพลตฟอร์มช่องทางเสียวหมี่เพื่อขายอุปกรณ์ให้แก่ผู้ซื้อ และรวมถึงผู้ขายบุคคลที่สาม
            โดยปกติคือผู้จัดจำหน่ายในกรณีที่ผู้ซื้อเป็นผู้ค้าปลีกนิติบุคคลเสียวหมี่ท้องถิ่นอาจเป็นผู้ขายได้เช่นกัน.
          </li>
          <li>
            {fonSizeBold("ผู้ขายบุคคลที่สาม")} หมายถึง ผู้ขายที่ใช้แพลตฟอร์มช่องทางเสียวหมี่เพื่อขายอุปกรณ์ให้แก่ผู้ซื้อ และไม่รวมถึงนิติบุคคลจัดหาสินค้าเสียวหมี่.
          </li>
          <li>
            {fonSizeBold("ข้อกำหนดและเงื่อนไข (“ข้อกำหนดและเงื่อนไข” หรือ “T&C”)")} หมายความว่า สัญญาฉบับนี้ที่กำหนดความสัมพันธ์ระหว่างผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่            .
          </li>
          <li>
            {fonSizeBold("ผู้ใช้")} หมายความว่า ผู้ที่ใช้คุณสมบัติของแพลตฟอร์มช่องทางเสียวหมี่เพื่อซื้อและขายอุปกรณ์ รวมถึงผู้ซื้อและผู้ขาย.
          </li>
          <li>
            {fonSizeBold("แพลตฟอร์มช่องทางเสียวหมี่")} หมายความว่า เว็บไซต์ เว็บไซต์บนมือถือ และแอปพลิเคชันบนมือถือของแพลตฟอร์มช่องทางเสียวหมี่ (ซึ่งต่อไปนี้จะเรียกว่า “แพลตฟอร์ม”) ซึ่งผู้ซื้อสามารถเข้าถึงและใช้คุณสมบัติต่าง ๆ ได้.
          </li>
          <li>
            {fonSizeBold("นิติบุคคลจัดหาสินค้าเสียวหมี่")} หมายความว่า นิติบุคคลใด ๆ ในกลุ่มเสียวหมี่ที่อาจจัดหาอุปกรณ์.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>คุณสมบัติ</span>
        <p className={getSty("title-explain")}>
          แพลตฟอร์มช่องทางเสียวหมี่มีคุณสมบัติที่อำนวยความสะดวกในการซื้ออุปกรณ์ของผู้ซื้อ ซึ่งรวมถึงแต่ไม่จำกัดเพียง,
        </p>
        <ol>
          <li>
            {fonSizeBold("โปรไฟล์ของผู้ซื้อ")}
            <p>
            โดยการใช้คุณสมบัตินี้ ผู้ซื้อสามารถ (1) ตรวจสอบข้อมูลในส่วน “บัญชี” เกี่ยวกับข้อมูลพื้นฐาน เช่น ข้อมูลการจดทะเบียนธุรกิจ ข้อมูลภาษี ข้อมูลผู้ถือหุ้น ข้อมูลที่อยู่จัดส่ง ข้อมูลบัญชีธนาคาร และเอกสารแนบที่เกี่ยวข้อง; และ (2) ตรวจสอบในส่วน “บัญชี” สัญญาหรือข้อตกลงที่ได้ทำขึ้นระหว่างผู้ซื้อและนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง.
            </p>
          </li>
          <li>
            {fonSizeBold("การดูข้อมูลทางการเงิน")}
            <p className={`${styles["mb-8"]} ${styles["mt-8"]}`}>
              โดยการใช้ฟีเจอร์นี้ ผู้ซื้อสามารถดูเครดิตโน้ตที่ผู้ซื้อได้ใช้ไปแล้ว.
            </p>
            <p className={`${styles["mb-8"]} ${styles["mt-8"]}`}>
              {fonSizeBold(
                "เพื่อป้องกันความสงสัย ข้อมูลและรายละเอียดที่แสดงในส่วนนี้ใช้เป็นข้อมูลอ้างอิงสำหรับการกระทบยอดเท่านั้น หากผู้ซื้อมีข้อสงสัยเกี่ยวกับข้อมูลและรายละเอียดที่แสดง สามารถติดต่อผู้จัดการฝ่ายขายที่ได้รับมอบหมายจากผู้ขายที่เกี่ยวข้องได้."
              )}
            </p>
          </li>
          <li>
            {fonSizeBold("การจัดการคำสั่งซื้อ")} means (1) any information
            <p>
            ผ่านคุณสมบัตินี้ ผู้ซื้อสามารถ (1) ตรวจสอบสถานะของคำสั่งซื้อก่อนหน้าที่วางไว้ภายในสาม (03) เดือน; (2) ตรวจสอบใบส่งสินค้าสำหรับคำสั่งซื้อที่วางไว้ภายในสาม (03) เดือน; และ (3) วางคำสั่งซื้อกับผู้ขายที่เกี่ยวข้อง เพื่อซื้ออุปกรณ์โดยกรอกและส่งคำสั่งซื้อออนไลน์ตามแบบฟอร์มที่แสดงบนแพลตฟอร์มช่องทางเสียวหมี่.
            </p>
            <p>
            เมื่อวางคำสั่งซื้อ ผู้ซื้อต้องกรอกข้อมูลทั้งหมดที่จำเป็น คำสั่งซื้อจะถือว่าได้ส่งเมื่อผู้ซื้อกดส่งไปยังผู้ขายที่เกี่ยวข้อง และจะถือว่าได้รับเมื่อพนักงานคนแรกของผู้ขายที่รับผิดชอบการขายอุปกรณ์ได้รับคำสั่งซื้อ.
            </p>
            <p>
              หากคำสั่งซื้อถูกปฏิเสธโดยผู้ขาย จะมีหนังสือแจ้งเป็นลายลักษณ์อักษรส่งไปยังผู้ซื้อ หรือผู้ซื้อจะถูกติดต่อโดยผู้จัดการฝ่ายขายที่ผู้ขายแต่งตั้ง.
            </p>
            <p>
            กรณีที่ผู้ซื้อวางคำสั่งซื้อบนแพลตฟอร์มช่องทางเสียวหมี่เพื่อซื้ออุปกรณ์ที่ขายโดยหน่วยงานท้องถิ่นของเสียวหมี่ และหน่วยงานท้องถิ่นของเสียวหมี่ยอมรับคำสั่งซื้อดังกล่าว จะถือเป็นความสัมพันธ์ตามสัญญาที่ทำขึ้นโดยตรงระหว่างผู้ซื้อและหน่วยงานท้องถิ่นของเสียวหมี่.
            </p>
            <p>
              ในทางกลับกัน, หากผู้ซื้อวางคำสั่งซื้อบนแพลตฟอร์มช่องทางเสียวหมี่เพื่อซื้ออุปกรณ์ที่ขายโดยผู้ขายบุคคลที่สา
              ม และผู้ขายบุคคลที่สามยอมรับคำสั่งซื้อดังกล่าว จะถือเป็นความสัมพันธ์ตามสัญญาที่ทำขึ้นโดยตรงระหว่างผู้ซื้อและผู้ขายบุคคลที่สาม ในกรณีนี้ หน่วยงานท้องถิ่นของเสียวหมี่ไม่ได้เป็นคู่สัญญาในสัญญาหรือข้อตกลงใด ๆ ระหว่างผู้ซื้อและผู้ขายบุคคลที่สาม และไม่ต้องรับภาระใด ๆ ที่เกี่ยวข้องกับข้อตกลงดังกล่าว คู่สัญญาในสัญญาหรือข้อตกลงดังกล่าวต้องรับผิดชอบต่อข้อตกลงระหว่างกันเอง การลงรายการอุปกรณ์ การรับประกันการซื้อ และเรื่องอื่น ๆ ด้วยตนเองทั้งหมด.
            </p>
            <p>
              ผู้ซื้อสามารถเพิกถอนคำสั่งซื้อได้ก่อนที่ผู้ขายจะยอมรับ หากคำสั่งซื้อถูกปฏิบัติบางส่วนหรือไม่ถูกปฏิบัติเลย
              ทั้งผู้ซื้อหรือผู้ขายสามารถเริ่มกระบวนการยุติคำสั่งซื้อได้.
              {fonSizeBold(
                "หากผู้ขายเป็นฝ่ายเริ่มกระบวนการยุติ จะมีอีเมลส่งไปยังผู้ซื้อ ผู้ซื้อสามารถยอมรับหรือปฏิเสธการยุติคำสั่งซื้อได้ หากผู้ซื้อไม่ตอบกลับอีเมลภายในสาม (03) วันทำการ คำสั่งซื้อดังกล่าวจะถือว่ายุติโดยทั้งสองฝ่าย. "
              )}
            </p>
            <p>
            หากข้อมูลของผู้ซื้อมีการเปลี่ยนแปลงจนส่งผลกระทบต่อการปฏิบัติตามคำสั่งซื้อ หน่วยงานจัดหาของเสียวหมี่มีสิทธิ์ระงับการดำเนินการคำสั่งซื้อเป็นระยะเวลาที่สมเหตุสมผล หรือดำเนินมาตรการที่เหมาะสมอื่น ๆ โดยไม่ต้องรับภาระค่าใช้จ่ายหรือความรับผิดเพิ่มเติมใด ๆ.
            </p>
          </li>
          <div className={styles["mg-42"]}>
            {fonSizeBold(
              "เพื่อความชัดเจน ผู้ซื้อยอมรับว่า ข้อกำหนดและเงื่อนไขที่ระบุในแบบฟอร์มคำสั่งซื้อบนแพลตฟอร์มช่องทางเสียวหมี่ เป็นข้อกำหนดและเงื่อนไขที่ได้หารือกับหน่วยงานจัดหาของเสียวหมี่ที่เกี่ยวข้อง และในกรณีที่ผู้ซื้อตั้งคำสั่งซื้อผ่านฟีเจอร์นี้ ผู้ซื้อนั้นยอมรับและตกลงผูกพันตามข้อกำหนดและเงื่อนไขในคำสั่งซื้อนั้น.  "
            )}
          </div>
          <li>
            {fonSizeBold("การจัดการการจัดจำหน่าย")}
            <p>
              ผ่านคุณสมบัตินี้ ผู้ซื้อสามารถกรอกและจัดการคำสั่งซื้อจัดจำหน่ายซึ่งแสดงถึงการรับสินค้า การขาย หรือการคืนอุปกรณ์ได้.
            </p>
          </li>
          <li>
            {fonSizeBold("การรับข้อความ")}
            <p>
            ผ่านคุณสมบัตินี้ ผู้ซื้อสามารถรับข้อความจากผู้ขายหรือนิติบุคคลจัดหาสินค้าเสียวหมี่ได้.
            </p>
          </li>
          <li>
            {fonSizeBold("คุณสมบัติอื่น ๆ")}
            <p>
              ผู้ซื้อยังสามารถตรวจสอบข้อมูลธุรกิจรวมบางส่วนตามฟังก์ชันข้างต้นได้.
            </p>
            <div className={styles["mg-42"]}>
              การเข้าถึงและการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ เป็นบริการฟรีสำหรับผู้ซื้อที่ตัดสินใจเข้าถึงและใช้แพลตฟอร์มช่องทางเสียวหมี่ด้วยความสมัครใจ.
            </div>
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>การยอมรับข้อกำหนดและเงื่อนไข</span>
        <ol>
          <li>
            ก่อนใช้คุณสมบัติ ผู้ใช้ต้องอ่านข้อกำหนดและเงื่อนไขอย่างละเอียด เข้าใจครบถ้วนทุกส่วน รวมถึงข้อกำหนดเกี่ยวกับ
            {fonSizeBold(
              " ข้อจำกัดความรับผิดชอบ, ข้อจำกัดความรับผิดของผู้ใช้ และ"
            )}
            , และ
            {fonSizeBold(" กฎหมายที่ใช้บังคับและเขตอำนาจศาล")}, และเลือกที่จะยอมรับหรือไม่ยอมรับข้อกำหนดและเงื่อนไขตามดุลยพินิจของผู้ใช้แต่เพียงผู้เดียว.
          </li>
          <li>
            โดยการลงทะเบียน เข้าสู่ระบบ การใช้คุณสมบัติ หรือการกระทำอื่นใด ผู้ใช้รับทราบว่าได้อ่านและเข้าใจอย่างครบถ้วน และตกลงที่จะยอมรับและผูกพันตามข้อกำหนดและเงื่อนไขดังกล่าว นิติบุคคลจัดหาสินค้าเสียวหมี่อาจระงับหรือหยุดให้บริการคุณสมบัติต่าง ๆ แก่ผู้ใช้ หากผู้ใช้ไม่ปฏิบัติตามข้อกำหนดและ/หรือ นโยบายบนแพลตฟอร์มช่องทางเสียวหมี่.
          </li>
          <li>
            The {fonSizeBold("นโยบายความเป็นส่วนตัว", "underline")} และ
            {fonSizeBold(" เอกสารที่มีผลผูกพันอื่น ๆ", "underline")} 
            ซึ่งมีให้แก่ผู้ใช้บนแพลตฟอร์มช่องทางเสียวหมี่ ถือเป็นข้อตกลงเสริมของข้อกำหนดและเงื่อนไข โดยมีผลทางกฎหมายและความถูกต้องเท่าเทียมกันหากผู้ใช้ใช้คุณสมบัติของแพลตฟอร์มช่องทางเสียวหมี่ ถือเป็นการยอมรับโดยนัยต่อข้อกำหนดและเงื่อนไข รวมถึงข้อตกลงเสริมดังกล่าวข้างต้น.
          </li>
          <li>
            ข้อกำหนดและเงื่อนไข รวมถึงข้อตกลงเสริมใด ๆ เมื่อจำเป็น อาจได้รับการแก้ไขเป็นครั้งคราวโดยนิติบุคคลจัดหาสินค้าเสียวหมี่ โดยการยอมรับข้อกำหนดและเงื่อนไข ผู้ใช้ตกลงที่จะยอมรับข้อจำกัดทั้งหมด รวมถึงการยอมรับให้นิติบุคคลจัดหาสินค้าเสียวหมี่สงวนสิทธิ์ในการแก้ไขข้อกำหนดและเงื่อนไขและข้อตกลงเสริมเหล่านั้นเป็นครั้งคราว โดยอาจมีหรือไม่มีการแจ้งให้ผู้ใช้ทราบล่วงหน้า ผู้ใช้สามารถเปิดแพลตฟอร์มช่องทางเสียวหมี่ได้ทุกเมื่อเพื่อตรวจสอบข้อกำหนดและเงื่อนไขและข้อตกลงเสริมฉบับล่าสุดซึ่งจะมีผลบังคับใช้ตั้งแต่เวลาที่เผยแพร่หากผู้ใช้ไม่สามารถยอมรับเนื้อหาใด ๆ ที่นิติบุคคลจัดหาสินค้าเสียวหมี่ได้เปลี่ยนแปลง ผู้ใช้จะต้องหยุดใช้คุณสมบัติของแพลตฟอร์มช่องทางเสียวหมี่โดยเด็ดขาดตามดุลยพินิจของตนเอง โดยการใช้คุณสมบัติต่อเนื่อง ผู้ใช้ตกลงที่จะยอมรับและผูกพันตามข้อกำหนดและเงื่อนไขและข้อตกลงเสริมที่ได้รับการแก้ไขแล้ว.
          </li>
          <li>
            ข้อกำหนดและเงื่อนไข รวมถึงข้อตกลงเสริม สัญญาจัดหาและซื้อขายที่เกี่ยวข้อง และเอกสารอื่น ๆ ที่อ้างอิงในข้อกำหนดและเงื่อนไข ถือเป็นสัญญาที่มีผลผูกพันทางกฎหมายระหว่างผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องในการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ หากผู้ใช้ไม่ยอมรับข้อกำหนดและเงื่อนไข ข้อตกลงเสริม และ/หรือบันทึก แจ้งเตือนทางกฎหมาย ข้อมูลที่เผยแพร่หรืออ้างอิงในนั้น ผู้ใช้จะไม่ขอเปิดบัญชี ลงทะเบียน เข้าสู่ระบบ หรือใช้แพลตฟอร์มช่องทางเสียวหมี่หรือคุณสมบัติที่เกี่ยวข้อง ซึ่งจะเป็นการตัดสินใจโดยผู้ใช้แต่เพียงผู้เดียว.
          </li>
          <li>
            นิติบุคคลจัดหาสินค้าเสียวหมี่สงวนสิทธิ์แต่ไม่ผูกพันที่จะเปลี่ยนแปลงตามดุลยพินิจของตนเองและเป็นครั้งคราว แม้หลังจากที่ผู้ใช้ได้ลงทะเบียนแล้ว กราฟิกอินเทอร์เฟซของแพลตฟอร์มช่องทางเสียวหมี่ คุณสมบัติ เนื้อหาที่มีอยู่บนแพลตฟอร์มช่องทางเสียวหมี่และการจัดระเบียบ รวมถึงคุณสมบัติอื่นใดที่เป็นลักษณะเฉพาะของการทำงานและการจัดการแพลตฟอร์มช่องทางเสียวหมี่ โดยจะแจ้งคำแนะนำที่เกี่ยวข้องแก่ผู้ใช้เมื่อจำเป็นเวอร์ชันที่แก้ไขของแพลตฟอร์มช่องทางเสียวหมี่ การแนะนำคุณสมบัติใหม่ และการอัปเดตหรือการเปลี่ยนแปลงอื่น ๆ ของคุณสมบัติที่มีอยู่ จะอยู่ภายใต้ข้อกำหนดและเงื่อนไขรวมถึงข้อตกลงเสริม.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>การลงทะเบียนและเข้าสู่ระบบแพลตฟอร์มช่องทางเสียวหมี่</span>
        <ol>
          <li>
            ด้วยความประสงค์ที่จะใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ ผู้ใช้สามารถขอรับบัญชีสำหรับแพลตฟอร์มช่องทางเสียวหมี่โดยส่งคำขออย่างเป็นทางการไปยังนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง 
            (ต่อไปนี้เรียกว่า “{fonSizeBold("บัญชี")}”), ซึ่งสอดคล้องกับคุณสมบัติทั้งหมดหรือบางส่วน และจะดำเนินการโดยพนักงานที่ได้รับการแต่งตั้งและได้รับอนุญาตจากผู้ใช้เพื่อวัตถุประสงค์นี้ 
            ผู้ใช้จำเป็นต้องระบุชื่อเต็มของพนักงานที่ได้รับอนุญาตให้เข้าถึงบัญชี พร้อมกับอีเมลและ/หรือข้อมูลอื่น ๆ ที่จำเป็นเมื่อเปิดใช้งานแล้ว บัญชีจะถูกจัดส่งให้แก่ผู้ใช้โดยนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง พร้อมกับรหัสผ่านเริ่มต้นของบัญชีดังกล่าว ในการเข้าถึงบัญชีครั้งแรก ผู้ใช้จำเป็นต้องเปลี่ยนรหัสผ่านเริ่มต้น.
          </li>
          <li>
            เพื่อเข้าสู่ระบบแพลตฟอร์มช่องทางเสียวหมี่และใช้ประโยชน์จากคุณสมบัติ ผู้ใช้และ/หรือพนักงานที่ได้รับอนุญาตของผู้ใช้ต้องกรอกข้อมูลรับรองการเข้าสู่ระบบ (ที่อยู่อีเมลและรหัสผ่านที่เลือก ฯลฯ) บัญชีสามารถใช้ได้เฉพาะกับพนักงานที่ได้รับการแต่งตั้งและได้รับอนุญาตจากผู้ใช้เท่านั้น.
          </li>
          <li>
            ผู้ใช้ตกลงและรับรองว่าตนมีความรับผิดชอบต่อความปลอดภัยของข้อมูลบัญชีและรหัสผ่านของตนเอง และต้องรับผิดชอบทางกฎหมายต่อกิจกรรมที่เกิดขึ้นภายใต้บัญชีของตน การเข้าสู่ระบบและการเข้าถึงแพลตฟอร์มช่องทางเสียวหมี่โดยบุคคลที่ไม่ได้รับอนุญาต ถือเป็นความรับผิดชอบแต่เพียงผู้เดียวของผู้ใช้ และผู้ใช้ต้องชดใช้ค่าเสียหายแก่ นิติบุคคลจัดหาสินค้าเสียวหมี่ รวมถึงบริษัทในเครือของนิติบุคคลจัดหาสินค้าเสียวหมี่ สำหรับความสูญเสีย ความเสียหาย 
            และค่าชดเชยแก่บุคคลที่สามที่ได้รับผลกระทบจากการเข้าถึงดังกล่าว.{" "}
          </li>
          <li>
            ผู้ใช้ยังเข้าใจ รับทราบ และตกลงว่า นิติบุคคลจัดหาสินค้าเสียวหมี่ มีสิทธิ์ในการเปลี่ยนแปลง ปรับปรุง ระงับ จำกัด ยกเลิก หรือเพิกถอนบัญชีได้ทุกเมื่อ ทั้งชั่วคราวหรือถาวร โดยไม่ต้องแจ้งให้ทราบล่วงหน้า และไม่มีความรับผิดชอบใด ๆ ต่อความสูญเสียหรือความเสียหายที่เกิดขึ้น.{" "}
          </li>
          <li>
            {fonSizeBold("นโยบายความเป็นส่วนตัว")}. นิติบุคคลจัดหาสินค้าเสียวหมี่อาจเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลจากผู้ใช้ และ/หรือบุคลากรของผู้ใช้ 
            เพื่อวัตถุประสงค์ในการสื่อสารและพัฒนาความสัมพันธ์ทางธุรกิจร่วมกันของคู่สัญญา ปฏิบัติตามข้อผูกพันทางกฎหมาย และเพื่อให้เป็นไปตามข้อกำหนดและเงื่อนไขโดยทั่วไป ข้อมูลส่วนบุคคลดังกล่าวจะถูกเก็บรวบรวมและประมวลผลตามนโยบายความเป็นส่วนตัว ซึ่งสามารถตรวจสอบได้ก่อนการขอรับบัญชี เมื่อเข้าสู่ระบบแพลตฟอร์มช่องทางเสียวหมี่เป็นครั้งแรก และ/หรือที่ส่วนท้ายของหน้าหลักของแพลตฟอร์มช่องทางเสียวหมี่บัญชี เมื่อเข้าสู่ระบบแพลตฟอร์มช่องทางเสียวหมี่เป็นครั้งแรกและ/หรือที่ด้านล่างของหน้าแรกของแพลตฟอร์มช่องทางเสียวหมี่            .
          </li>
          <div className={styles['text-indent-2']}>
            {fonSizeBold('โดยการยอมรับนโยบายความเป็นส่วนตัว ผู้ใช้ยืนยันความยินยอมในการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลที่ให้ไว้โดยนิติบุคคลจัดหาสินค้าเสียวหมี่หรือบริษัทในเครือของตน.')}
          </div>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>การยกเลิกและปิดบัญชี</span>
        <ol>
          <li>
            หากผู้ใช้ประสงค์จะระงับการใช้งานหรือยกเลิกบัญชี สามารถส่งหนังสือแจ้งเป็นลายลักษณ์อักษรไปยังผู้ติดต่อที่นิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องได้.
          </li>
          <li>
          ในกรณีที่ผู้ใช้ละเมิดข้อกำหนดและเงื่อนไข ข้อตกลงเสริม และ/หรือบทบัญญัติกฎหมายที่ใช้บังคับ นิติบุคคลจัดหาสินค้าเสียวหมี่ขอสงวนสิทธิ์ในการระงับหรือปิดบัญชีที่เกี่ยวข้องได้ทุกเมื่อโดยไม่ต้องแจ้งให้ทราบล่วงหน้า.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span className={styles["line-1-4"]}>
          ความสัมพันธ์ตามสัญญาระหว่างผู้ซื้อและผู้ขาย
        </span>
        <ol>
          <li>
            ความสัมพันธ์ตามสัญญาจัดหาและซื้อขายระหว่างผู้ซื้อและผู้ขายที่เกี่ยวข้องจะถูกควบคุมโดยข้อกำหนดและเงื่อนไข ข้อตกลงเสริม สัญญาจัดหาและซื้อขาย และคำสั่งซื้อที่ทำขึ้นระหว่างกัน ซึ่งรวมถึงคำสั่งซื้อออนไลน์ที่ผู้ซื้อทำและผู้ขายที่เกี่ยวข้องตกลงผ่านแพลตฟอร์มช่องทางเสียวหมี่.
          </li>
          <li>
            ผู้ซื้อรับทราบและตกลงว่าคำสั่งซื้อออนไลน์ที่ทำผ่านแพลตฟอร์มช่องทางเสียวหมี่และได้รับการอนุมัติจากผู้ขายที่เกี่ยวข้องในรูปแบบอิเล็กทรอนิกส์ ถือเป็นการปฏิบัติตามข้อกำหนดทางกฎหมายที่ว่าข้อตกลง สัญญา และคำสั่งซื้อดังกล่าวต้องเป็นลายลักษณ์อักษร 
            และคำสั่งซื้อเหล่านี้มีผลบังคับใช้เต็มรูปแบบซึ่งผู้ซื้อจะต้องปฏิบัติตามอย่างครบถ้วน.
          </li>
          <li>
            ในกรณีเกิดความขัดแย้ง เอกสารจะมีลำดับความสำคัญตามลำดับดังต่อไปนี้จากมากไปน้อย: ข้อกำหนดและเงื่อนไขพร้อมด้วยการแก้ไขและข้อตกลงเสริม, สัญญาจัดหาและซื้อขาย, หนังสือมอบอำนาจ, คำสั่งซื้อคำสั่งซื้อนี้ไม่ใช้บังคับเมื่อความขัดแย้งเกี่ยวข้องกับการจัดส่ง บริการและการสนับสนุน รวมถึงการกำหนดเขตพื้นที่ ซึ่งข้อกำหนดในคำสั่งซื้อที่สะท้อนในแต่ละคำสั่งซื้อจะมีลำดับความสำคัญ.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span className={styles["line-1-4"]}>
          เนื้อหาที่อัปโหลดโดยนิติบุคคลจัดหาสินค้าเสียวหมี่
        </span>
        <ol>
          <li>
            สำหรับบางส่วนของแพลตฟอร์มช่องทางเสียวหมี่ เนื้อหาเกี่ยวกับผู้ใช้สามารถถูกโพสต์และอัปโหลดโดยนิติบุคคลจัดหาสินค้าเสียวหมี่ตามเอกสารที่ผู้ใช้จัดเตรียมไว้ (เนื้อหาที่อัปโหลดโดยเสียวหมี่) สำหรับเนื้อหาที่อัปโหลดโดยเสียวหมี่ เช่น ข้อมูลการลงทะเบียนของผู้ใช้ ผู้ใช้ควรตรวจสอบ ยืนยัน และรับรองความถูกต้อง ความชอบด้วยกฎหมาย ความถูกต้อง และความมีผลบังคับใช้ของข้อมูลดังกล่าว.
          </li>
          <li>
            ในกรณีที่มีความไม่ถูกต้องหรือการเปลี่ยนแปลงในเนื้อหาที่อัปโหลดโดยเสียวหมี่ ผู้ใช้ควรแจ้งให้นิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องทราบโดยทันที มิฉะนั้น ผู้ใช้จะต้องรับผิดชอบความเสี่ยงและความเสียหายทั้งหมดที่เกิดขึ้น.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>คำชี้แจงและการรับประกันของผู้ใช้</span>
        <ol>
          <li>
            ผู้ใช้แถลง รับประกัน และตกลงว่า (1) มีอำนาจเต็มที่และสิทธิ์ในการยอมรับข้อกำหนดและเงื่อนไขและข้อตกลงเสริม รวมถึงการให้สิทธิ์และการอนุญาต และการปฏิบัติตามภาระผูกพันภายใต้ข้อกำหนดและเงื่อนไขนี้; และ (2) การเข้าถึงและการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ จะเป็นไปเพื่อวัตถุประสงค์ทางธุรกิจเท่านั้น และเป็นไปตามข้อกำหนดและเงื่อนไขและข้อตกลงเสริม.
          </li>
          <li>
            ผู้ใช้ต้องให้ข้อมูลหรือเอกสารเกี่ยวกับนิติบุคคลหรือธุรกิจของตนเป็นส่วนหนึ่งของกระบวนการล
            งทะเบียนบนแพลตฟอร์มช่องทางเสียวหมี่เพื่อเข้าถึงและใช้คุณสมบัติหรือบัญชีใด ๆ ผู้ใช้แถลง รับประกัน และตกลงว่า (1) ข้อมูลและเอกสารดังกล่าว ไม่ว่าจะส่งก่อน ระหว่าง หรือหลังจากกระบวนการลงทะเบียน และตลอดระยะเวลาการใช้แพลตฟอร์มช่องทางเสียวหมี่หรือคุณสมบัติ เป็นความจริง ถูกต้อง ทันสมัย และครบถ้วน ไม่เป็นเท็จ หลอกลวง หรือทำให้เข้าใจผิด;และ (2) จะรักษาและแก้ไขข้อมูลและเอกสารทั้งหมดให้เป็นความจริง ถูกต้อง ทันสมัย และครบถ้วนโดยทันที.
          </li>
          <li>
          ผู้ใช้แถลง รับประกัน และตกลงว่าจะใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติด้วยความสุจริตใจและเป็นไปตามกฎหมายที่บังคับใช้ทั้งหมด รวมถึงกฎหมายที่ผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ตั้งอยู่ ข้อตกลงและนโยบายผู้ใช้ของไมโครซอฟท์ และข้อกำหนดและเงื่อนไขพร้อมข้อตกลงเสริม รับผิดชอบกิจกรรมทั้งหมดภายใต้บัญชีของผู้ใช้ และจะไม่ใช้แพลตฟอร์มช่องทางเสียวหมี่เพื่อการฉ้อโกง
          </li>
          <li>
          ผู้ใช้รับทราบว่าการแบ่งปันบัญชีของตนกับบุคคลอื่นหรืออนุญาตให้ผู้ใช้หลายรายนอกเหนือจากนิติบุคคลธุรกิจของตนใช้บัญชี อาจก่อให้เกิดความเสียหายที่ไม่อาจแก้ไขได้ต่อนิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือ และแถลง รับประกัน และตกลงว่าจะดูแลข้อมูลการลงทะเบียนและข้อมูลรับรองการเข้าสู่ระบบบนแพลตฟอร์มช่องทางเสียวหมี่อย่างดี และรับผิดชอบกิจกรรมทั้งหมดภายใต้บัญชีของตน.
          </li>
          <li>
          ผู้ใช้แถลง รับประกัน และตกลงว่าจะไม่ใช้บัญชีและรหัสผ่านของผู้ใช้อื่น และจะไม่สร้าง อัปโหลด หรือโพสต์ข้อมูลใด ๆ ในนามของผู้อื่นผู้ใช้ตกลงที่จะแจ้งให้นิติบุคคลจัดหาสินค้าเสียวหมี่ทราบทันทีเมื่อสงสัยว่ามีผู้อื่นใช้รหัสผ่านหรือบัญชีของตน โดยส่งอีเมลไปที่{" "}
            <a href="mailto:robot@xiaomi.com">robot@xiaomi.com</a>.
          </li>
          <li>
            ผู้ใช้รับรองและตกลงว่าจะไม่ให้ นิติบุคคลจัดหาสินค้าเสียวหมี่ และบริษัทในเครือของตนได้รับความเสียหาย การชดใช้ค่าเสียหาย และ/หรือบทลงโทษใด ๆ ที่เกิดขึ้นจากและ/หรือเกี่ยวข้องกับการละเมิดกฎการลงทะเบียนแพลตฟอร์มช่องทางเสียวหมี่ การใช้ข้อมูลรับรองการเข้าสู่ระบบ ข้อกำหนดร้านค้า และกฎการใช้งาน หรือการกระทำอื่นใดของผู้ใช้; มิฉะนั้น นิติบุคคลจัดหาสินค้าเสียวหมี่ขอสงวนสิทธิ์ในการระงับบัญชีและการเข้าถึงแพลตฟอร์มช่องทางเสียวหมี่ และผู้ใช้จะต้องรับผิดชอบทางกฎหมายทั้งหมดโดยสมบูรณ์เสียวหมี่ไม่รับผิดชอบหรือมีภาระผูกพันใด ๆ ต่อคำร้องเรียนหรือความเสียหายใด ๆ ที่เกิดจากการกระทำของผู้ใช้.
          </li>
        </ol>
      </div>
      <div className={`${getSty("item-box")} ${styles["bold-box"]}`}>
        <span>ข้อจำกัดความรับผิด </span>
        <ol>
          <li>
          หน่วยงานจัดหาของเสียวหมี่และบริษัทในเครือจะไม่รับผิดชอบทางกฎหมายภายใต้สถานการณ์ดังต่อไปนี้:
          </li>
          <div className={styles["disorderly"]}>
          การให้ข้อมูลของผู้ใช้ตามคำขอของหน่วยงานรัฐบาลหรือกฎหมายที่บังคับใช้.
          </div>
          <div className={styles["disorderly"]}>
          การเปิดเผยข้อมูลส่วนตัวที่เกิดจากการกระทำของผู้ใช้.
          </div>
          <div className={styles["disorderly"]}>
          การเปิดเผยข้อมูลที่ถูกห้ามตามกฎหมายที่บังคับใช้ รวมถึงกฎหมายของประเทศที่ผู้ใช้และหน่วยงานจัดหาของเสียวหมี่ที่เกี่ยวข้องตั้งอยู่.
          </div>
          <div className={styles["disorderly"]}>
          สถานการณ์ใด ๆ ที่เกิดจากการระงับ การขัดข้อง ฯลฯ ซึ่งเกิดจากการถูกแฮ็ก การแพร่กระจายไวรัส การบล็อกเนื้อหาที่ผิดกฎหมายหรือเป็นการรบกวน
          การควบคุมของรัฐบาล หรือเหตุผลอื่นใดที่เกี่ยวข้องกับเครือข่าย เทคนิค สายสื่อสาร และการจัดการความปลอดภัยข้อมูล.
          </div>
          <div className={styles["disorderly"]}>
          ความสูญเสียของผู้ใช้หรือบุคคลภายนอกที่ได้รับผลกระทบซึ่งเกิดจากบุคคลที่สาม เช่น การขัดข้องของสายสื่อสาร ปัญหาทางเทคนิค เครือข่ายหรือคอมพิวเตอร์ล่ม และกรณีอื่น ๆ ที่เป็นเหตุสุดวิสัย.
          </div>
          <div className={styles["disorderly"]}>
          ความเสี่ยงที่เกิดจากการคุกคาม การหมิ่นประมาท ข้อมูลที่ละเมิดกฎหมายหรือไม่เหมาะสม ซึ่งเกิดจากผู้ไม่ประสงค์ออกนามหรือการแพร่ผ่านแพลตฟอร์มช่องทางเสียวหมี่.
          </div>
          <div className={styles["disorderly"]}>
          ความสูญเสีย การเรียกร้อง หรือคดีความที่เกิดจากความประมาทและ/หรือความผิดของผู้ใช้ในข้อกำหนดใด ๆ ภายใต้ข้อกำหนดและเงื่อนไข (T&C).
          </div>

          <li>
          แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ ให้บริการ “ตามสภาพ” และ “ตามที่มีอยู่” และนิติบุคคลจัดหาของเสียวหมี่และ/หรือบริษัทในเครือ ไม่ให้การรับประกันใด ๆ ทั้งโดยชัดแจ้งหรือโดยนัย เกี่ยวกับแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติ ทั้งในเรื่องความทันเวลา ความปลอดภัย และความถูกต้อง ไม่ว่าจะชัดแจ้ง โดยนัย หรือในรูปแบบอื่นใด อีกทั้งหน่วยงานจัดหาของเสียวหมี่และ/หรือบริษัทในเครือ ไม่ได้รับประกันว่าแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติจะตอบสนองความต้องการของผู้ใช้ หรือจะไม่ถูกขัดจังหวะ ไม่มีข้อผิดพลาด หรือปราศจากไวรัสและบั๊ก.
          </li>
          <li>
          นิติบุคคลจัดหาของเสียวหมี่และบริษัทในเครือจะพยายามให้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ สามารถใช้งานได้อย่างต่อเนื่อง 24 ชั่วโมงต่อวัน แต่ไม่สามารถรับผิดชอบใด ๆ หากด้วยเหตุผลใดก็ตาม แพลตฟอร์มช่องทางเสียวหมี่และ/หรือคุณสมบัติไม่สามารถเข้าถึงหรือใช้งานได้ในช่วงเวลาใด ๆ หรือเป็นระยะเวลาใด ๆ การเข้าถึงแพลตฟอร์มช่องทางเสียวหมี่และ/หรือคุณสมบัติอาจถูกระงับชั่วคราวในกรณีที่เกิดความล้มเหลวของระบบ การบำรุงรักษา การซ่อมแซม หรือเหตุผลอื่นใดที่ไม่เกี่ยวข้องกับเจตนาของนิติบุคคลจัดหาของเสียวหมี่และบริษัทในเครือ หรือเกิดจากเหตุสุดวิสัย ซึ่งในกรณีดังกล่าว นิติบุคคลของเสียวหมี่จะพยายามแจ้งให้ผู้ใช้ทราบ.
          </li>
          <li>
          ภายใต้สถานการณ์ใด ๆ หน่วยงานจัดหาของเสียวหมี่และ/หรือบริษัทในเครือจะไม่รับผิดชอบต่อความเสียหายทางอ้อม ผลลัพธ์ตามมา ความเสียหายเชิงตัวอย่าง ความเสียหายโดยบังเอิญ ความเสียหายพิเศษ หรือความเสียหายเชิงลงโทษใด ๆ รวมถึงการสูญเสียกำไรที่เกิดจากการใช้แพลตฟอร์มช่องทางเสียวหมี่หรือฟีเจอร์ ผู้ใช้เป็นผู้รับความเสี่ยงทั้งหมดจากการใช้ระบบคอมพิวเตอร์และฐานข้อมูลบนมือถือผ่านแพลตฟอร์มช่องทางเสียวหมี่หรือฟีเจอร์.
          </li>
        </ol>
      </div>
      <div className={`${getSty("item-box")} ${styles["bold-box"]}`}>
        <span>ข้อจำกัดความรับผิดชอบ</span>
        <ol>
          <li>
          นิติบุคคลจัดหาสินค้าเสียวหมี่จะไม่รับผิดชอบต่อผู้ใช้ เว้นแต่ในกรณีที่มีการกระทำโดยเจตนาหรือความประมาทเลินเล่ออย่างร้ายแรง สำหรับความบกพร่องหรือความผิดปกติที่เกี่ยวข้องกับการใช้บริการอินเทอร์เน็ตซึ่งอยู่นอกเหนือการควบคุมของนิติบุคคลจัดหาสินค้าเสียวหมี่หรือผู้จัดหาของตน.
          </li>
          <li>
          นอกจากนี้ นิติบุคคลจัดหาสินค้าเสียวหมี่จะไม่รับผิดชอบต่อความเสียหาย ขาดทุน และค่าใช้จ่ายที่เกิดขึ้นแก่ผู้ใช้ อันเนื่องมาจากความล้มเหลวในการปฏิบัติตามข้อกำหนดและเงื่อนไขด้วยเหตุผลที่ไม่สามารถนำมาจากนิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตน.
          </li>
          <li>นิติบุคคลจัดหาสินค้าเสียวหมี่จะไม่รับผิดชอบต่อ:</li>
          <div className={styles["disorderly"]}>
          การสูญเสียโอกาสทางธุรกิจและความเสียหายอื่นใด แม้แต่ทางอ้อม ที่ผู้ใช้อาจได้รับ ซึ่งไม่ใช่ผลโดยตรงจากการละเมิดข้อกำหนดและเงื่อนไขโดยนิติบุคคลจัดหาสินค้าเสียวหมี่;
          </div>
          <div className={styles["disorderly"]}>
          การใช้แพลตฟอร์มช่องทางเสียวหมี่โดยผู้ใช้หรือบุคคลที่สามในทางที่ผิดกฎหมาย ไม่ถูกต้อง หรือไม่เหมาะสม.
          </div>
          <li>
          ในกรณีที่ นิติบุคคลจัดหาสินค้าเสียวหมี่ มีความรับผิดชอบต่อการละเมิด ข้อกำหนดและเงื่อนไข ความรับผิดชอบดังกล่าวจะจำกัดอยู่ที่ความเสียหายซึ่ง นิติบุคคลจัดหาสินค้าเสียวหมี่ ต้องคาดหมายได้ตามปกติ ณ เวลาที่ทำสัญญา ข้อกำหนดและเงื่อนไข โดยพิจารณาจากสถานการณ์ที่ทราบในขณะนั้น อย่างไรก็ตาม ความเสียหายดังกล่าวจะไม่เกิน 100 USD (หรือเทียบเท่าในสกุลเงินท้องถิ่น).
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>ความรับผิดของผู้ใช้</span>
        <ol>
          <li>
          ผู้ใช้มีความรับผิดชอบโดยสมบูรณ์ต่อการละเมิดข้อผูกพันภายใต้:
          </li>
          <div className={styles["disorderly"]}>
          ข้อกำหนดและเงื่อนไข รวมถึงข้อตกลงเสริม.
          </div>
          <div className={styles["disorderly"]}>
          กฎหมายที่บังคับใช้ในเขตอำนาจศาลที่เกี่ยวข้อง รวมถึงเขตอำนาจที่ผู้ใช้ตั้งอยู่ หรือที่ผู้ใช้เข้าถึงและใช้ แพลตฟอร์มช่องทางเสียวหมี่ หรือที่ตั้งของ นิติบุคคลจัดหาสินค้าเสียวหมี่ ที่เกี่ยวข้อง.
          </div>
          <div className={`${styles["mt-12"]} ${styles["text-indent-2"]}`}>
            {fonSizeBold(
              "สำหรับผลที่เกิดจากการละเมิดดังกล่าว รวมถึงความสูญเสียหรือความเสียหายใด ๆ ที่ นิติบุคคลจัดหาสินค้าเสียวหมี่ บริษัทในเครือ หรือบุคคลที่สามอาจได้รับหรือต้องประสบ นิติบุคคลจัดหาสินค้าเสียวหมี่ และบริษัทในเครือจะไม่มีความรับผิดชอบใด ๆ ต่อผู้ใช้หรือบุคคลที่สามใด ๆ ในเรื่องการละเมิดดังกล่าว."
            )}
          </div>
          <div
            className={`${styles["mt-12"]} ${styles["mb-8"]} ${styles["text-indent-2"]}`}
          >
            {fonSizeBold(
              "ผู้ใช้ต้องรับผิดชอบและรับรองให้นิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตนปลอดภัยจากความรับผิดชอบหรือภาระผูกพันใด ๆ ที่เกิดขึ้นจากการกระทำของผู้ใช้."
            )}
          </div>
          <li>
          ผู้ใช้ต้องไม่ใช้แพลตฟอร์มช่องทางเสียวหมี่หรือคุณสมบัติใด ๆ เพื่อกระทำพฤติกรรมหรือกิจกรรมดังต่อไปนี้:
          </li>
          <div className={styles["disorderly"]}>
            อัปโหลดหรือปล่อยไวรัส เวิร์ม หรือมัลแวร์เพื่อทำลายหรือเปลี่ยนแปลงระบบคอมพิวเตอร์หรือข้อมูล.
          </div>
          <div className={styles["disorderly"]}>
          รวบรวมข้อมูลหรือข้อมูลใด ๆ ของผู้อื่น เช่น ที่อยู่อีเมล โดยไม่ได้รับอนุญาตและความยินยอมโดยตรงจากเจ้าของข้อมูล และเป็นไปตามกฎหมายที่บังคับใช้.
          </div>
          <div className={styles["disorderly"]}>
          ปิดกั้นการเชื่อมต่อเครือข่ายของแพลตฟอร์มช่องทางเสียวหมี่ ทำให้แพลตฟอร์มช่องทางเสียวหมี่มีปริมาณการใช้งานเกินขีดจำกัด รบกวนหรือทำลายเซิร์ฟเวอร์และการเชื่อมต่อในรูปแบบอื่น ๆ.
          </div>
          <div className={styles["disorderly"]}>
          พยายามเข้าถึงแพลตฟอร์มช่องทางเสียวหมี่ เซิร์ฟเวอร์ หรือการเชื่อมต่อของแพลตฟอร์มช่องทางเสียวหมี่โดยไม่ได้รับอนุญาต.
          </div>
          <div className={styles["disorderly"]}>
          รบกวนหรือทำลายการใช้งานปกติของผู้ใช้อื่นในคุณสมบัติ;
          </div>
          <div className={styles["disorderly"]}>
          กระทำการใด ๆ ที่ผิดกฎหมายตามกฎหมายที่บังคับใช้ รวมถึงกฎหมายที่ผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ของผู้ใช้ตั้งอยู่.
          </div>
          <div
            className={`${styles["mt-12"]} ${styles["mb-12"]}  ${styles["text-indent-2"]}`}
          >
            {fonSizeBold(
              " ผู้ใช้ต้องรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการกระทำดังกล่าวข้างต้น โดยให้นิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตนปลอดภัยจากความเสียหายดังกล่าว."
            )}
          </div>
          <li>
            ผู้ใช้ตกลงที่จะใช้แพลตฟอร์มช่องทางเสียวหมี่หรือคุณสมบัติอย่างถูกต้องตามกฎหมาย โดยไม่ก่อให้เกิดความเสียหาย และรับผิดชอบต่อคดีความ ข้อร้องเรียน ความสูญเสีย ความเสียหาย ความรับผิดชอบ ค่าใช้จ่าย และค่าธรรมเนียม (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความ) รวมถึงข้อเรียกร้องของบุคคลที่สามที่เกิดจากการใช้แพลตฟอร์มช่องทางเสียวหมี่หรือคุณสมบัติและการละเมิดข้อกำหนดและเงื่อนไขนิติบุคคลจัดหาสินค้าเสียวหมี่และ/หรือบริษัทในเครือของตนสงวนสิทธิ์เฉพาะในการปกป้องสิทธิและสิทธิ์ในการเรียกร้องค่าเสียหาย
          </li>
          {/* <div
            className={`${styles["mt-8"]} ${styles["mb-8"]} ${styles["text-indent-2"]}`}
          >
            
          </div> */}
          <li>
            ผู้ใช้จะไม่ยอมความโดยลำพังเมื่อผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องร่วมกันฟ้องร้องบุคคลที่สามโดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากนิติบุคคลจัดหาสินค้าเสียวหมี่ นิติบุคคลจัดหาสินค้าเสียวหมี่จะต้องแจ้งให้ผู้ใช้ทราบอย่างสมเหตุสมผลเกี่ยวกับคดีหรือการดำเนินคดีดังกล่าว.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>การรักษาความลับ</span>
        <ol>
          <li>
          ผู้ใช้พร้อมด้วยบุคลากรของตนจะต้องเก็บรักษาข้อมูลที่เป็นความลับไว้เป็นความลับตลอดเวลา และจะไม่ใช้หรือเปิดเผยข้อมูลที่เป็นความลับเพื่อวัตถุประสงค์อื่นใดนอกเหนือจากการปฏิบัติหรือตามสิทธิและหน้าที่ตามข้อกำหนดและเงื่อนไขและ/หรือสิทธิและหน้าที่อื่นใดที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติ เว้นแต่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากนิติบุคคลจัดหาสินค้าเสียวหมี่หรือบริษัทในเครือ.
          </li>
          <li>
          ผู้ใช้จะต้องดำเนินมาตรการรักษาความปลอดภัยอย่างเข้มงวดเพื่อปกป้องข้อมูลที่เป็นความลับ รวมถึงแต่ไม่จำกัดเพียงการจัดตั้งระบบความลับ ฝึกอบรมบุคคลที่เกี่ยวข้องซึ่งอาจเข้าถึงข้อมูลที่เป็นความลับ ลงนามในข้อตกลงไม่เปิดเผยข้อมูลกับบุคคลดังกล่าว และเน้นย้ำถึงความลับของข้อมูลที่เป็นความลับ มาตรการรักษาความปลอดภัย และความรับผิดชอบในกรณีละเมิดข้อตกลงดังกล่าว.
          </li>
          <li>
          เว้นแต่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องและ/หรือบริษัทในเครือ ผู้ใช้จะต้องไม่ทำการย้อนรอยวิศวกรรม ถอดรหัส หรือแยกชิ้นส่วนข้อมูลที่เป็นความลับใด ๆ (ทั้งที่จับต้องได้และที่ไม่จับต้องได้) ที่เปิดเผยแก่ผู้ใช้ และจะต้องไม่ลบ ปิดทับ หรือทำลายข้อความแจ้งลิขสิทธิ์ เครื่องหมายการค้า โลโก้ คำอธิบาย หรือข้อความแจ้งความเป็นเจ้าของอื่นใดจากต้นฉบับหรือสำเนาของข้อมูลที่เป็นความลับที่นิติบุคคลจัดหาสินค้าเสียวหมี่และ/หรือบริษัทในเครือเปิดเผย.
          </li>
          <li>
          เมื่อได้รับคำขอจากนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องในทุกเวลา ผู้ใช้จะต้อง (i) คืนข้อมูลที่เป็นความลับทั้งหมด เอกสารหรือสื่อที่บรรจุข้อมูลที่เป็นความลับดังกล่าว รวมถึงสำเนาหรือสาระสำคัญของข้อมูลนั้นทั้งหมดให้แก่นิติบุคคลจัดหาสินค้าเสียวหมี่และ/หรือบริษัทในเครือ หรือ (ii) ทำลายเอกสารหรือสื่อที่บรรจุข้อมูลที่เป็นความลับดังกล่าว รวมถึงสำเนาหรือสาระสำคัญของข้อมูลนั้นทั้งหมด และจัดทำหนังสือรับรองเป็นลายลักษณ์อักษรเกี่ยวกับการทำลายดังกล่าว โดยลงนามโดยผู้แทนที่ได้รับมอบอำนาจของผู้ใช้.
          </li>
          <li>
            ผู้ใช้จะต้องรับผิดชอบต่อการรั่วไหลของข้อมูลที่เป็นความลับโดยบุคลากรของตน.
          </li>
          <li>
            ผู้ใช้จะต้องปฏิบัติตามข้อตกลงไม่เปิดเผยข้อมูลที่ได้ทำไว้กับนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง เมื่อข้อกำหนดเกี่ยวกับข้อมูลที่เป็นความลับนี้ขัดแย้งกับบทบัญญัติของข้อตกลงไม่เปิดเผยข้อมูลดังกล่าว บทบัญญัติที่เข้มงวดกว่าจะมีผลบังคับใช้.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>เหตุสุดวิสัย</span>
        <ol>
          <li>
          ผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องจะไม่ต้องรับผิดชอบต่อความล้มเหลวหรือความล่าช้าในการปฏิบัติตามภาระผูกพันของตน เนื่องจากสถานการณ์ที่อยู่นอกเหนือการควบคุมอย่างสมเหตุสมผลของตน อันเนื่องมาจากเหตุสุดวิสัย หรือในกรณีใด ๆ ที่เป็นเหตุการณ์ที่ไม่คาดคิดและไม่อาจคาดการณ์ได้ และในทุกกรณีที่อยู่นอกเหนือความประสงค์ของตน.
          </li>
          <li>
            การปฏิบัติตามภาระผูกพันโดยผู้ใช้หรือนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องจะถือเป็นการระงับชั่วคราวในช่วงเวลาที่เกิดเหตุสุดวิสัย.
          </li>
          <li>
          ผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องจะดำเนินการทุกอย่างในอำนาจของตนเพื่อค้นหาวิธีแก้ไขที่อนุญาตให้ปฏิบัติตามภาระผูกพันได้อย่างถูกต้องแม้ในขณะที่เหตุสุดวิสัยยังคงมีอยู่.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>ระยะเวลาและการยกเลิกสัญญา</span>
        <ol>
          <li>
            ข้อกำหนดและเงื่อนไขจะมีผลบังคับใช้ตั้งแต่ครั้งแรกที่ผู้ใช้ตกลงยอมรับข้อกำหนดและเงื่อนไข หรือครั้งแรกที่ผู้ใช้ใช้คุณสมบัติใด ๆ แล้วแต่เหตุการณ์ใดจะเกิดขึ้นก่อน และจะยังคงมีผลบังคับใช้ตลอดระยะเวลาที่ผู้ใช้ใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ จนกว่าจะมีการยกเลิกก่อนตามกฎหมายที่บังคับใช้และข้อกำหนดและเงื่อนไขนี้.
          </li>
          <li>
            นิติบุคคลจัดหาสินค้าเสียวหมี่อาจยกเลิกข้อกำหนดและเงื่อนไขและยกเลิกบัญชีของผู้ใช้ได้ทุกเมื่อโดยไม่ต้องแจ้งให้ทราบล่วงหน้าในกรณีที่ผู้ใช้ละเมิดข้อกำหนดและเงื่อนไขและ/หรือมีพฤติกรรมที่ผิดกฎหมายในการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ ตามกฎหมายที่บังคับใช้ รวมถึงกฎหมายของสถานที่ตั้งของผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่.
          </li>
          <div className={`${styles["mt-8"]} ${styles["mb-8"]}`}>
            {fonSizeBold(
              "นิติบุคคลจัดหาสินค้าเสียวหมี่สงวนสิทธิ์นี้ไว้เช่นกัน แม้ว่าจะมีเพียงข้อสงสัยว่าผู้ใช้ได้ละเมิดข้อกำหนดดังกล่าวข้างต้น."
            )}
          </div>
          <li>
            ไม่อยู่ภายใต้บทบัญญัติก่อนหน้านี้ นิติบุคคลจัดหาสินค้าเสียวหมี่สงวนสิทธิ์ในการยกเลิกข้อกำหนดและเงื่อนไขหากผู้ใช้ละเมิดสิทธิในทรัพย์สินทางปัญญาของบุคคลที่สาม หรือได้รับแจ้งจากเจ้าของสิทธิหรือผู้แทนทางกฎหมายของเจ้าของสิทธิ.
          </li>
          <li>
            เมื่อข้อกำหนดและเงื่อนไขถูกยกเลิก บัญชีทั้งหมดและสิทธิของผู้ใช้ในการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ จะถูกยกเลิกด้วยเช่นกันผู้ใช้ควรเข้าใจว่านี่หมายถึงเนื้อหาบนแพลตฟอร์มช่องทางเสียวหมี่ที่เกี่ยวข้องกับผู้ใช้อาจถูกลบออกจากฐานข้อมูลของนิติบุคคลจัดหาสินค้าเสียวหมี่หรือบริษัทในเครือของตน โดยไม่กระทบต่อภาระผูกพันทางกฎหมายใดๆ ในเรื่องนี้นิติบุคคลจัดหาสินค้าเสียวหมี่จะไม่รับผิดชอบใดๆ ต่อการยกเลิกข้อกำหนดและเงื่อนไข รวมถึงการยกเลิกบัญชีและการลบเนื้อหาบนแพลตฟอร์มช่องทางเสียวหมี่ที่เกี่ยวข้องกับผู้ใช้.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>บุคคลที่สาม</span>
        <ol>
          <li>
            ผู้ใช้เข้าใจและยอมรับว่าแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติของแพลตฟอร์มอาจจำเป็นต้องได้รับการสนับสนุนทางเทคนิคจากบุคคลที่สามผู้ใช้เข้าใจและยินยอมให้นิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตนอาจให้ข้อมูลส่วนบุคคลบางส่วนของผู้ใช้แก่บุคคลที่สามดังกล่าวในระหว่างการรับการสนับสนุนทางเทคนิคหรือการสนับสนุนอื่นใดจากบุคคลที่สามเหล่านั้นผู้ใช้ตกลงและอนุญาตให้มีการจำกัดสิทธิ์บางประการตามบริการหรือซอฟต์แวร์ของบุคคลที่สาม.
          </li>
          <li>
            ผู้ใช้เข้าใจและยอมรับว่าแพลตฟอร์มช่องทางเสียวหมี่อาจมีลิงก์ไปยังเว็บไซต์หรือแอปพลิเคชันของบุคคลที่สามนิติบุคคลจัดหาสินค้าเสียวหมี่ไม่มีอำนาจควบคุมเว็บไซต์หรือแอปพลิเคชันดังกล่าว ดังนั้นจึงไม่รับผิดชอบใดๆ ต่อเนื้อหาของเว็บไซต์หรือแอปพลิเคชันเหล่านั้น.
          </li>
          <li>
            เมื่อผู้ใช้เข้าชมแอปพลิเคชัน เว็บไซต์ และโฆษณาของบุคคลที่สาม ข้อกำหนดและนโยบายของบุคคลที่สามนั้นจะมีผลบังคับใช้ผู้ใช้จะต้องรับความเสี่ยงและความรับผิดชอบทางกฎหมายทั้งหมดเมื่อใช้บริการของบุคคลที่สาม.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>สิทธิในทรัพย์สินทางอุตสาหกรรมและทรัพย์สินทางปัญญา</span>
        <ol>
          <li>
          นิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตนขอประกาศว่าเป็นผู้ได้รับอนุญาตหรือเจ้าของสิทธิในทรัพย์สินทางปัญญาที่จำเป็นทั้งหมดที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่ คุณสมบัติ และ/หรือเนื้อหาที่มีอยู่บนแพลตฟอร์มช่องทางเสียวหมี่ ความลับทางการค้า เครื่องหมายการค้า รูปภาพหรือคำ และเครื่องหมายอื่นใด ชื่อทางการค้า เครื่องหมายบริการ เครื่องหมายคำ ชื่อทางการค้า ภาพประกอบ รูปภาพ โลโก้ และเนื้อหาที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่ คุณสมบัติ และ/หรือเนื้อหาที่มีอยู่บนแพลตฟอร์มช่องทางเสียวหมี่ทั้งหมดได้รับการคุ้มครองตามกฎหมายที่บังคับใช้เกี่ยวกับความลับทางการค้า เครื่องหมายการค้า ลิขสิทธิ์ สิทธิของผู้ประพันธ์ ฯลฯ และตามสนธิสัญญาระหว่างประเทศที่เกี่ยวข้อง.
          </li>
          <li>
          ข้อกำหนดและเงื่อนไขนี้ไม่ได้มอบใบอนุญาตใด ๆ แก่ผู้ใช้สำหรับการใช้งานที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่ และ/หรือเนื้อหาและ/หรือวัสดุที่มีอยู่ในนั้น เว้นแต่จะมีการกำหนดไว้เป็นอย่างอื่น.
          </li>
          <li>
          การทำซ้ำในทุกรูปแบบของข้อความอธิบายและเนื้อหาของแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติใด ๆ ของแพลตฟอร์มหากไม่ได้รับอนุญาต จะถือเป็นการละเมิดสิทธิในทรัพย์สินทางปัญญาและทรัพย์สินทางอุตสาหกรรมของนิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือของตน.
          </li>
          <li>
          ผู้ใช้ถูกห้ามขาย ให้เช่า โอน ปล่อย หรือใช้ประโยชน์เชิงพาณิชย์อื่นใดจากเนื้อหาที่มีอยู่บนแพลตฟอร์มช่องทางเสียวหมี่ (รวมถึงแต่ไม่จำกัดเพียงเนื้อหาที่อาจเป็นทรัพย์สินของบุคคลที่สาม).
          </li>
          <li>
          ผู้ใช้จะต้องไม่เข้าถึงแพลตฟอร์มช่องทางเสียวหมี่ หรือใช้คุณสมบัติ และคัดลอกเนื้อหาเพื่อสร้างเว็บไซต์หรือแอปพลิเคชันที่มีลักษณะคล้ายคลึงกัน.
          </li>
          <li>
          เว้นแต่จะมีการกำหนดไว้อย่างชัดแจ้งโดยกฎหมายหรือข้อกำหนดและเงื่อนไข ผู้ใช้จะต้องไม่คัดลอก เผยแพร่ ดาวน์โหลด เปลี่ยนแปลง แปล รวม รวมเข้าด้วยกัน แยกส่วน วาง หรือถอดรหัส ฯลฯ ส่วนใดส่วนหนึ่งของแพลตฟอร์มช่องทางเสียวหมี่ คุณสมบัติ และเนื้อหาในทุกกรณี.
          </li>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>ประกาศ</span>
        <ol>
          <li>
          การแจ้งเตือนหรือการสื่อสารอื่นใดแก่ผู้ใช้ที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติ จะต้องเป็นภาษาอังกฤษและเป็นลายลักษณ์อักษร ส่งมอบด้วยตนเอง ส่งทางไปรษณีย์ลงทะเบียน หรือส่งทางแฟกซ์หรืออีเมล และต้องระบุถึงที่อยู่ติดต่อสุดท้ายที่ผู้ใช้ได้ให้ไว้บนแพลตฟอร์มช่องทางเสียวหมี่ หรือที่อยู่หรือรายละเอียดอื่นใดที่ผู้ใช้อาจแจ้งให้เสียวหมี่ทราบเป็นลายลักษณ์อักษรเพื่อวัตถุประสงค์ดังกล่าว.
          </li>
          <li>
          การแจ้งเตือนหรือการสื่อสารอื่นใดแก่ นิติบุคคลจัดหาสินค้าเสียวหมี่ ที่เกี่ยวข้องกับแพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติ จะต้องทำเป็นลายลักษณ์อักษรและส่งทางอีเมลไปที่{" "}
            <a href="mailto:robot@xiaomi.com">robot@xiaomi.com</a> 
            หรือที่อยู่หรือรายละเอียดอื่นใดที่นิติบุคคลจัดหาสินค้าเสียวหมี่อาจแจ้งแก่ผู้ใช้เป็นลายลักษณ์อักษรเพื่อวัตถุประสงค์ดังกล่าว.
          </li>
          <li>
            ผู้ใช้ตกลงว่า ข้อตกลง ประกาศ คำร้อง การเปิดเผยข้อมูล และการสื่อสารอื่นใดทั้งหมดที่นิติบุคคลจัดหาสินค้าเสียวหมี่ส่งให้ผู้ใช้อย่างอิเล็กทรอนิกส์ จะถือเป็นการปฏิบัติตามข้อกำหนดทางกฎหมายที่กำหนดให้การสื่อสารดังกล่าวต้องเป็นลายลักษณ์อักษร.
          </li>
        </ol>
      </div>
      <div className={`${getSty("item-box")} ${getSty("bold-box")}`}>
        <span>กฎหมายที่ใช้บังคับและเขตอำนาจศาล</span>
        <ol>
          <li>
          ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้บังคับของกฎหมายฮ่องกงโดยไม่คำนึงถึงหลักการข้อขัดแย้งของกฎหมาย ตราบเท่าที่ไม่ขัดแย้งกับกฎบังคับใด ๆ ที่ใช้บังคับในเขตพื้นที่ที่ผู้ใช้และ/หรือ นิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องตั้งอยู่ รวมทั้งข้อกำหนดและเงื่อนไขของใบอนุญาตที่บุคคลที่สามมอบให้แก่บริษัทในเครือของนิติบุคคลจัดหาสินค้าเสียวหมี่เกี่ยวกับการใช้แพลตฟอร์มช่องทางเสียวหมี่.
          </li>
          <li>
          ข้อพิพาท ข้อโต้แย้ง ความแตกต่าง หรือคำเรียกร้องใด ๆ ที่เกิดขึ้นจากหรือเกี่ยวข้องกับข้อกำหนดและเงื่อนไขนี้ รวมถึงการมีอยู่ ความถูกต้อง การบังคับใช้ การปฏิบัติตาม การละเมิด หรือการยกเลิกข้อกำหนดและเงื่อนไขนี้ หรือข้อพิพาทใด ๆ ที่เกี่ยวข้องกับภาระผูกพันที่ไม่ใช่สัญญาซึ่งเกิดขึ้นจากหรือเกี่ยวข้องกับข้อกำหนดและเงื่อนไขนี้ จะต้องถูกส่งต่อและได้รับการระงับข้อพิพาทโดยอนุญาโตตุลาการที่ดำเนินการโดยศูนย์อนุญาโตตุลาการนานาชาติฮ่องกง (HKIAC) ภายใต้กฎอนุญาโตตุลาการ UNCITRAL ที่ใช้บังคับในขณะที่มีการยื่นคำแจ้งอนุญาโตตุลาการ โดยได้รับการปรับแก้ตามขั้นตอนของ HKIAC สำหรับการบริหารอนุญาโตตุลาการระหว่างประเทศ.
          </li>
          <div className={styles["mt-8"]}>
          ข้อพิพาทจะได้รับการพิจารณาโดยอนุญาโตตุลาการเพียงหนึ่งเดียว ซึ่งต้องได้รับความเห็นชอบจากผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง หรือหากฝ่ายต่าง ๆ ไม่สามารถตกลงกันได้ภายในหนึ่งเดือนนับจากวันที่มีการส่งหนังสือแจ้งการอนุญาโตตุลาการ จะให้ประธาน HKIAC แต่งตั้งอนุญาโตตุลาการดังกล่าว.
          </div>
          <div className={styles["mt-8"]}>
            การอนุญาโตตุลาการจะดำเนินการเป็นภาษาอังกฤษและจัดขึ้น ณ เขตบริหารพิเศษฮ่องกง.
          </div>
          <div className={styles["mt-8"]}>
            ไม่มีข้อใดในข้อตกลงนี้ที่จะป้องกันไม่ให้ผู้ใช้หรือนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้องขอคำสั่งคุ้มครองชั่วคราวหรือคำสั่งที่คล้ายคลึงกันจากศาลที่มีเขตอำนาจที่เหมาะสม หากจำเป็นเพื่อบังคับใช้สิทธิของตนภายใต้ข้อกำหนดและเงื่อนไข และเพื่อวัตถุประสงค์นี้ แต่ละฝ่ายตกลงอย่างไม่อาจเพิกถอนได้ว่า ศาลในฮ่องกงมีเขตอำนาจเฉพาะในการระงับข้อพิพาทหรือคำเรียกร้องดังกล่าว.{" "}
          </div>
        </ol>
      </div>
      <div className={getSty("item-box")}>
        <span>บทบัญญัติทั่วไป</span>
        <ol>
          <li>
            หากบทบัญญัติใดของข้อกำหนดและเงื่อนไขนี้ถูกตัดสินให้เป็นโมฆะ ผิดกฎหมาย หรือไม่สามารถบังคับใช้ได้ในประการใด ประสิทธิผล ความถูกต้องตามกฎหมาย และการบังคับใช้ของบทบัญญัติที่เหลืออยู่จะไม่ถูกกระทบหรือเสื่อมเสียในทางใด ๆ.
          </li>
          <li>
            นิติบุคคลจัดหาสินค้าเสียวหมี่สงวนสิทธิ์ในการมอบหมายหรือโอนสิทธิและหน้าที่ใด ๆ ทั้งหมดภายใต้ข้อกำหนดและเงื่อนไขนี้แก่บริษัทในเครือ ผู้ใช้ หรือสมาชิกในกลุ่มเสียวหมี่ได้ทุกเมื่อโดยไม่ต้องแจ้งให้ผู้ใช้ทราบล่วงหน้า อย่างไรก็ตาม ในกรณีที่มีการเปลี่ยนแปลงดังกล่าว สิทธิของผู้ใช้ตามข้อกำหนดและเงื่อนไขนี้จะไม่ถูกกระทบในทางลบแต่อย่างใด ผู้ใช้ไม่อาจมอบหมายสิทธิและหน้าที่ของตนตามข้อกำหนดและเงื่อนไขนี้โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากนิติบุคคลจัดหาสินค้าเสียวหมี่ที่เกี่ยวข้อง การกระทำหรือกิจกรรมใดที่ฝ่าฝืนบทบัญญัตินี้ถือเป็นโมฆะ.
          </li>
          <li>
            ข้อกำหนดและเงื่อนไขนี้ รวมถึงข้อตกลงเสริมและเอกสารอื่น ๆ ที่อ้างอิงในที่นี้ ถือเป็นข้อตกลงขั้นสุดท้าย สมบูรณ์ และเฉพาะเจาะจงระหว่างผู้ใช้และนิติบุคคลจัดหาสินค้าเสียวหมี่เกี่ยวกับการใช้แพลตฟอร์มช่องทางเสียวหมี่และคุณสมบัติต่าง ๆ.
          </li>
          <li>
          หัวข้อของแต่ละย่อหน้าจัดทำขึ้นเพื่อความสะดวกในการอ่านเท่านั้น และไม่มีผลผูกพันทางกฎหมายหรือสัญญาใดๆ.{" "}
          </li>
          <li>
          ข้อกำหนดและเงื่อนไขรวมถึงข้อตกลงเสริมนี้ มิได้มีเจตนาหรือก่อให้เกิดความสัมพันธ์ในรูปแบบตัวแทน หุ้นส่วน ร่วมทุน ลูกจ้างนายจ้าง หรือผู้ให้สิทธิแฟรนไชส์และผู้รับสิทธิแฟรนไชส์.{" "}
          </li>
          <li>
          การที่นิติบุคคลจัดหาสินค้าเสียวหมี่และบริษัทในเครือไม่ใช้สิทธิตามข้อกำหนดและเงื่อนไขนี้ ไม่ถือเป็นการสละสิทธิดังกล่าว หรือการสละสิทธิ์ในกรณีการละเมิดที่เกิดขึ้นในภายหลังหรือในลักษณะเดียวกันการสละสิทธิ์จะมีผลบังคับใช้ได้ก็ต่อเมื่อทำเป็นลายลักษณ์อักษรเท่านั้น.{" "}
          </li>
          <li>
          หากนิติบุคคลจัดหาสินค้าเสียวหมี่แปลและเผยแพร่ข้อกำหนดและเงื่อนไขในภาษาอื่น ผู้ใช้ตกลงว่าการแปลดังกล่าวจัดทำขึ้นเพื่อความสะดวกเท่านั้น และเวอร์ชันภาษาอังกฤษของข้อกำหนดและเงื่อนไขจะเป็นข้อกำหนดที่ใช้บังคับในการใช้แพลตฟอร์มช่องทางเสียวหมี่ เว้นแต่จะถูกห้ามโดยกฎหมายที่ใช้บังคับ.
          </li>
        </ol>
      </div>
      <footer>ฉบับปรับปรุงล่าสุด: 20 สิงหาคม 2567</footer>
    </div>
  );
}
